// Exported so ColumnMenuOptionsTabMobile can render the same options as plain
// buttons (DropdownItem only fires onClick inside a real <Dropdown> ancestor —
// see ColumnMenuOptionsTabMobile's doc comment). Labels are translation keys
// (+ the en text as defaultValue) resolved at render time.
export const PIN_OPTIONS: {
  labelKey: string;
  defaultLabel: string;
  value: 'LEFT' | 'RIGHT' | null;
}[] = [
  {labelKey: 'page.datagrid.labels.noPin', defaultLabel: 'No pin', value: null},
  {labelKey: 'page.datagrid.labels.pinLeft', defaultLabel: 'Pin left', value: 'LEFT'},
  {labelKey: 'page.datagrid.labels.pinRight', defaultLabel: 'Pin right', value: 'RIGHT'},
];
